"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WirelessInsurance_1 = require("./WirelessInsurance");
exports.default = WirelessInsurance_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/WirelessCart/WirelessInsurance/index.js
// module id = 2362
// module chunks = 8